import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';

/**
 * @component BulkActions
 * @description
 * Componente que representa un conjunto de acciones masivas (bulk actions) para aplicar a elementos seleccionados.
 * Llama a una función externa `onBulkAction` pasando el tipo de acción seleccionado.
 *
 * @param {Function} onBulkAction - Función callback que maneja la acción seleccionada desde el componente padre.
 *
 * @returns {JSX.Element}
 *
 * @example
 * <BulkActions onBulkAction={(action) => console.log(action)} />
 */
const BulkActions = ({ onBulkAction }) => {
	const [selectedAction, setSelectedAction] = useState('');

	const handleChange = (e) => {
		setSelectedAction(e.target.value);
	};

	const handleApply = () => {
		if (selectedAction && onBulkAction) {
			onBulkAction(selectedAction);
		}
	};

	return (
		<div className="d-flex">
			<Form.Select size="sm" aria-label="Bulk actions" onChange={handleChange}>
				<option value="">Acciones</option>
				<option value="export">Exportar</option>
				<option value="delete">Eliminar</option>
			</Form.Select>
			<Button
				type="button"
				variant="falcon-default"
				size="sm"
				className="ms-2"
				onClick={handleApply}
			>
				Aplicar
			</Button>
		</div>
	);
};

export default BulkActions;